import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
//import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
//import { process, State, CompositeFilterDescriptor } from '@progress/kendo-data-query';
//import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
//import { startWith, map, tap } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierLookup,
    City,
    CustomerLookup,
    DataCollection,
    Employee,
    EquipmentClass,
    Mode,
    Product,
    //OrderStop,
    QuoteOrderLine,
    QuoteOrderLinePlannedLoad,
    QuoteOrderLinePlannedLoadRequest,
    QuoteOrderLinePriority,
    RFQQuoteLoad,
    SearchCustomerTeam,
    //SearchQuoteOrderLine,
    SearchTagType,
    TrailerType
} from '../../models/models';

@Component({
    selector: 'order-planned',
    templateUrl: './order-planned.component.html',
    standalone: false
})
export class OrderPlanned implements OnInit {
    public isLoading: boolean = false;
    //public quoteOrderLines: QuoteOrderLine[] = [];
    public quoteOrderLinesPlanned: QuoteOrderLinePlannedLoad[] = [];
    //public orderStops: OrderStop[] = [];
    private quoteOrderLinesPlannedSearched: QuoteOrderLinePlannedLoad[] = [];
    //private loadsRFQQuoteSearched: SearchQuoteOrderLine[] = [];
    private loadsRFQQuoteSearched: RFQQuoteLoad[] = [];
    public orderOwners: Employee[] = [];
    public accountReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public salesReps: Employee[] = [];
    public orderCreatedByEmployees: Employee[] = [];
    public logisticSpecialists: SearchCustomerTeam[] = [];
    public quoteOrderLinePriorityList: QuoteOrderLinePriority[] = [];
    public c2cList: string[] = [];
    private selectedC2C: string[] = [];

    public tagTypeList: SearchTagType[] = [];
    public selectedTagTypes: SearchTagType[] = [];
    public isTagListFocus: boolean = false;

    public ordersGrid: QuoteOrderLinePlannedLoad[] = [];
    public loadsPlanned: QuoteOrderLinePlannedLoad[] = [];
    public loadsAvailable: QuoteOrderLinePlannedLoad[] = [];
    // Combine Tendered, Accepted, and Dispatched
    public loadsTendered: QuoteOrderLinePlannedLoad[] = [];
    public loadsAccepted: QuoteOrderLinePlannedLoad[] = [];
    public loadsDispatched: QuoteOrderLinePlannedLoad[] = [];
    public loadsStarted: QuoteOrderLinePlannedLoad[] = [];
    public loadsCompleted: QuoteOrderLinePlannedLoad[] = [];
    public loadsRFQQuote: RFQQuoteLoad[] = [];
    public resultsView: string = "Grids";
    public isShowPlanned: boolean = true;
    public isShowAvailable: boolean = true;
    // Combine Tendered, Accepted, and Dispatched
    public isShowTendered: boolean = true;
    public isShowAccepted: boolean = false;
    public isShowDispatched: boolean = false;
    public isShowStarted: boolean = true;
    public isShowCompleted: boolean = false;
    public colSize: number = 3;
    public cardSize: number = 12;
    public divFlags = {
        'filters': true
    };
    public productList: Product[] = [];
    public modes: Mode[] = [];
    public equipmentClassList: EquipmentClass[] = [];
    public trailerTypeList: TrailerType[] = [];
    //public cities: City[] = [];
    //public filteredOrigins: Observable<City[]> = new Observable<City[]>();
    //public filteredDestinations: Observable<City[]> = new Observable<City[]>();
    public beginDate: Date = new Date(new Date().setDate(new Date().getDate() - 7));
    public endDate: Date = new Date(new Date().setDate(new Date().getDate() + 1));
    public dateWarning: string = "";
    public originControl = new UntypedFormControl();
    public destinationControl = new UntypedFormControl();
    public productID: number = 0;
    public modeId: number = 0;
    public equipmentClassID: number = 0;
    public trailerTypeID: number = 0;
    public customerId: number = 0;
    public orderOwnerEmployeeID: number = 0;
    public accountRepID: number = 0;
    public opsRepID: number = 0;
    public salesRepID: number = 0;
    public orderCreatedByEmployeeID: number = 0;
    public logisticSpecialistID: number = 0;
    public quoteOrderLinePriority: string = "";
    public isRoundTrip: boolean = false;
    public orderNumber: string = '';
    public refNum: string = '';
    //public orderOwner: string = '';
    public carrierCode: string = '';
    public parentCustomerCode: string = '';
    public customerCode: string = '';
    public accountManager: string = '';
    public opsRep: string = '';
    public csr: string = '';
    public orderCreatedBy: string = '';

    orderPlannedForm: UntypedFormGroup = new UntypedFormGroup({
        parentCtrl: new UntypedFormControl(''),
        billToCtrl: new UntypedFormControl(''),
        carrierCtrl: new UntypedFormControl(''),
        originControl: new UntypedFormControl(''),
        destinationControl: new UntypedFormControl('')
    });

    constructor(private dataService: DataService, private employeeService: EmployeeService, private orderService: OrderService,
        private utilService: UtilService, private router: Router, private titleService: Title) {
        this.titleService.setTitle('Planned Orders');
    }

    ngOnInit() {
        this.originControl.disable();
        this.destinationControl.disable();

        this.getEmployees();

        this.orderService.getProducts().subscribe(result => {
            this.productList = result;
            this.productList = this.productList.filter(t => t.isOrderEntryCompatible == true);
            this.productList = this.productList.sort((left, right): number => {
                if (left.productName < right.productName) return -1;
                if (left.productName > right.productName) return 1;
                return 0;
            });
        });

        this.orderService.getModes().subscribe(result => {
            this.modes = result;
        });

        this.orderService.getEquipmentClasses().subscribe(result => {
            this.equipmentClassList = result.resultCollection;
            this.equipmentClassList = this.equipmentClassList.sort((left, right): number => {
                if (left.abbreviation < right.abbreviation) return -1;
                if (left.abbreviation > right.abbreviation) return 1;
                return 0;
            });
        });

        this.orderService.getTrailerTypes().subscribe(result => {
            this.trailerTypeList = result;
            this.trailerTypeList = this.trailerTypeList.sort((left, right): number => {
                if (left.description < right.description) return -1;
                if (left.description > right.description) return 1;
                return 0;
            });
        });

        this.employeeService.GetSearchEmployeeCustomerTeamByCustomerTeamTypeDescription("Logistic Specialist").subscribe(result => {
            this.logisticSpecialists = result.resultCollection;
            this.logisticSpecialists = this.logisticSpecialists.sort((left, right): number => {
                if (left.employeeName < right.employeeName) return -1;
                if (left.employeeName > right.employeeName) return 1;
                return 0;
            });
        });

        this.orderService.getQuoteOrderLinePriorities().subscribe(result => {
            this.quoteOrderLinePriorityList = result.resultCollection;
        });

        this.orderService.getSearchTagTypes().subscribe(result => {
            var lst: SearchTagType[] = result.resultCollection;
            var orderTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrder");
            var loadTagTypes = lst.filter(t => t.recordTypeName == "QuoteOrderLine");
            var customerTagTypes = lst.filter(t => t.recordTypeName == "Customer");

            orderTagTypes = orderTagTypes.sort((left, right): number => {
                if (left.tagTypeName < right.tagTypeName) return -1;
                if (left.tagTypeName > right.tagTypeName) return 1;
                return 0;
            });

            loadTagTypes = loadTagTypes.sort((left, right): number => {
                if (left.tagTypeName < right.tagTypeName) return -1;
                if (left.tagTypeName > right.tagTypeName) return 1;
                return 0;
            });

            customerTagTypes = customerTagTypes.sort((left, right): number => {
                if (left.tagTypeName < right.tagTypeName) return -1;
                if (left.tagTypeName > right.tagTypeName) return 1;
                return 0;
            });

            this.tagTypeList = [...orderTagTypes, ...loadTagTypes, ...customerTagTypes];
            //console.log("ngOnInit", lst, orderTagTypes, loadTagTypes, customerTagTypes, this.tagTypeList);
        });

        this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
            var datCol: DataCollection = {
                name: "GetGetAllSearchOrderEventType",
                resultCollection: result
            }
            this.dataService.set(datCol);
        });

        this.orderService.getUnitOfMeasures().subscribe(result => {
            var datCol: DataCollection = {
                name: "GetUnitOfMeasures",
                resultCollection: result
            }
            this.dataService.set(datCol);
        });

        this.getLoads();
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            var reps = result.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            this.accountReps = reps;
            var datCol: DataCollection = {
                name: "GetEmployeesByGroupName-Account Managers",
                resultCollection: reps
            }
            this.dataService.set(datCol);
        });

        //this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
        //    var reps = result.sort((left, right): number => {
        //        if (left.fullName < right.fullName) return -1;
        //        if (left.fullName > right.fullName) return 1;
        //        return 0;
        //    });
        //    this.salesReps = reps;
        //    var datCol: DataCollection = {
        //        name: "GetEmployeesByGroupName-Sales",
        //        resultCollection: reps
        //    }
        //    this.dataService.set(datCol);
        //});

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            var reps = result.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            this.opsReps = reps;
            var datCol: DataCollection = {
                name: "GetEmployeesByGroupName-Ops Rep",
                resultCollection: reps
            }
            this.dataService.set(datCol);
        });

        this.employeeService.getEmployeesByGroupName('CarrierRep').subscribe(result => {
            var reps = result;
            reps = reps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < reps.length; i++) {
                reps[i].winUserName = (reps[i].winUserName == null ? "" : reps[i].winUserName.toUpperCase());
            }
            this.salesReps = reps;
            var datCol: DataCollection = {
                name: "GetEmployeesByGroupName-CarrierRep",
                resultCollection: reps
            }
            this.dataService.set(datCol);
        });

        //this.employeeService.getEmployeesERPAssignedTo().subscribe(result => {
        //    var reps = result.resultCollection;
        //    reps = reps.sort((left, right): number => {
        //        if (left.fullName < right.fullName) return -1;
        //        if (left.fullName > right.fullName) return 1;
        //        return 0;
        //    });
        //    for (var i = 0; i < reps.length; i++) {
        //        //reps[i].winUserName = (reps[i].winUserName == null ? "" : reps[i].winUserName.trim().toUpperCase());
        //        reps[i].erpUserId = (reps[i].erpUserId == null ? "" : reps[i].erpUserId.trim().toUpperCase());
        //    }
        //    var datCol: DataCollection = {
        //        name: "GetEmployeesERPAssignedTo",
        //        resultCollection: reps
        //    }
        //    this.dataService.set(datCol);
        //});

        this.employeeService.getActiveEmployees().subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            this.orderCreatedByEmployees = emps;
            this.orderOwners = emps.filter(t => t.activeInd == true && t.firstName != "New");
            //this.logisticSpecialists = Object.assign([], this.orderOwners);
            var datCol: DataCollection = {
                name: "GetAllEmployees",
                resultCollection: emps
            }
            this.dataService.set(datCol);
        });
    }

    private getC2CList() {
        this.c2cList.length = 0;
        for (var i = 0; i < this.quoteOrderLinesPlannedSearched.length; i++) {
            var c2c = this.quoteOrderLinesPlannedSearched[i].legCntryToCntry;
            if (this.c2cList.indexOf(c2c) < 0) {
                this.c2cList.push(c2c);
            }
        }
        //console.log("getC2CList", this.c2cList);
    }

    public getLoads() {
        this.isLoading = true;
        //var origin = this.originControl.value ? (this.originControl.value as City).cityST : '';
        //var destination = this.destinationControl.value ? (this.destinationControl.value as City).cityST : '';
        var originCity = this.orderPlannedForm.controls['originControl'].value as City;
        var destinationCity = this.orderPlannedForm.controls['destinationControl'].value as City;
        var origin = originCity.cityST;
        var destination = destinationCity.cityST;
        this.beginDate = new Date(this.beginDate.getFullYear(), this.beginDate.getMonth(), this.beginDate.getDate());
        this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate());
        var request: QuoteOrderLinePlannedLoadRequest = {
            startdate: this.beginDate,
            enddate: this.endDate,
            modeid: this.modeId,
            trailertypeid: 0,
            //origincityid: null,
            //destinationcityid: null,
            origincityst: origin,
            destinationcityst: destination
        }
        //console.log("getLoads", request);

        this.orderService.getQuoteOrderLinePlannedLoads(request).subscribe(result => {
            this.isLoading = false;
            this.quoteOrderLinesPlannedSearched = result.resultCollection;
            this.getC2CList();
            this.applyFilters();
        }, error => {
            this.isLoading = false;
            var ok = error;
        });

        //getSearchQuoteOrderLineByDateCity
        this.orderService.getRFQQuoteLoads(this.beginDate, this.endDate, origin, destination).subscribe(result => {
            //console.log("getSearchQuoteOrderLineByDateCity", result);
            this.loadsRFQQuoteSearched = result.resultCollection;
            this.loadsRFQQuoteSearched = this.loadsRFQQuoteSearched.filter(t => t.quoteOrderLineTypeAbbrev != "ORD");
            this.applyFilters();
        });
    }

    public getResultsView(view) {
        this.resultsView = view;
    }

    private applyFilters() {
        this.isLoading = true;
        this.quoteOrderLinesPlanned = JSON.parse(JSON.stringify(this.quoteOrderLinesPlannedSearched));
        this.loadsRFQQuote = JSON.parse(JSON.stringify(this.loadsRFQQuoteSearched));
        this.filterByOrderNumber();
        this.filterByRefNum();
        //this.filterByOrderOwner();
        this.filterByProduct();
        this.filterByEquipmentClass();
        this.filterByTrailerType();
        this.filterByParentCustomerCode();
        this.filterByCustomerCode();
        this.filterByCarrierCode();
        this.filterByPriority();
        this.filterByRoundTrip();
        this.filterByEmployees();
        this.filterByTagTypes();
        this.filterByC2C();
        this.filterStatuses();
        this.isLoading = false;
    }

    private filterByOrderNumber() {
        if (this.orderNumber != "") {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.orderNumber.indexOf(this.orderNumber) == 0);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.orderNumber.indexOf(this.orderNumber) == 0);
        }
    }

    private filterByRefNum() {
        if (this.refNum != "") {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.referenceNumbers.indexOf(this.refNum) >= 0);
        }
    }

    //private filterByOrderOwner() {
    //    if (this.orderOwner != "") {
    //        var owner = this.orderOwner.toUpperCase();
    //        this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.orderOwner.toUpperCase().indexOf(owner) == 0);
    //    }
    //}

    public onDateChange(fld: string) {
        this.dateWarning = "";
        var diffDays = this.utilService.getDateDiffDays(this.beginDate, this.endDate);
        if (diffDays > 62) {
            if (fld == "endDate") {
                this.dateWarning = "Maximum of 62 days for search";
                //this.beginDate = this.utilService.addDays(this.endDate, -62);
                this.endDate = this.utilService.addDays(this.beginDate, 62);
            }
            else if (fld == "beginDate") {
                this.dateWarning = "Maximum of 62 days for search";
                this.endDate = this.utilService.addDays(this.beginDate, 62);
            }
        }
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var val = this.orderPlannedForm.controls[ctrl].value;
        var selectedCustomer = val as CustomerLookup;
        console.log("onCustomerChange", evt, val, ctrl, selectedCustomer);
        if (ctrl == "billToCtrl") {
            if (selectedCustomer.customerCode) {
                this.customerCode = selectedCustomer.customerCode;
            }
            else if (!isNaN(evt)) {
                this.customerCode = val;
            }
            else {
                this.customerCode = "";
            }
        }
        else if (ctrl == "parentCtrl") {
            if (selectedCustomer.customerCode) {
                this.parentCustomerCode = selectedCustomer.customerCode;
            }
            else if (!isNaN(evt)) {
                this.parentCustomerCode = val;
            }
            else {
                this.parentCustomerCode = "";
            }
        }
        //if (!isNaN(evt) && evt != null) {
        //    this.editedOrderStop.customerId = evt;
        //}
        //else {
        //    this.editedOrderStop.customerId = selectedCustomer.customerID;
        //}
        //if (evt.option) {
        //    var lookup: CustomerLookup = evt.option.value;
        //    this.customerCode = lookup.customerCode;
        //}
        //else {
        //    this.customerCode = "";
        //}
        this.applyFilters();
    }

    public onCarrierChange(evt: any) {
        var val = this.orderPlannedForm.controls["carrierCtrl"].value;
        if (evt.option) {
            var lookup: CarrierLookup = evt.option.value;
            this.carrierCode = lookup.carrierCode;
        }
        else if (!isNaN(evt)) {
            this.carrierCode = val;
        }
        else {
            this.carrierCode = "";
        }
        this.applyFilters();
    }

    private filterByProduct() {
        if (this.productID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.productID == this.productID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.productID == this.productID);
        }
    }

    private filterByEquipmentClass() {
        if (this.equipmentClassID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.equipmentClassID == this.equipmentClassID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.equipmentClassID == this.equipmentClassID);
        }
    }

    private filterByTrailerType() {
        if (this.trailerTypeID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.trailerTypeID == this.trailerTypeID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.trailerTypeID == this.trailerTypeID);
        }
    }

    private filterByParentCustomerCode() {
        if (this.parentCustomerCode != "") {
            var code = this.parentCustomerCode.toUpperCase();
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => (o.parentCustomerCode == null ? "" : o.parentCustomerCode).toUpperCase().indexOf(code) == 0);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => (o.parentCustomerCode == null ? "" : o.parentCustomerCode).toUpperCase().indexOf(code) == 0);
        }
    }

    private filterByCustomerCode() {
        if (this.customerCode != "") {
            var code = this.customerCode.toUpperCase();
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => (o.customerCode == null ? "" : o.customerCode).toUpperCase().indexOf(code) == 0);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => (o.billToCustomerCode == null ? "" : o.billToCustomerCode).toUpperCase().indexOf(code) == 0);
        }
    }

    private filterByCarrierCode() {
        if (this.carrierCode != "") {
            var code = this.carrierCode.toUpperCase();
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => (o.carrierCode == null ? "" : o.carrierCode).toUpperCase().indexOf(code) == 0);
        }
    }

    private filterByPriority() {
        if (this.quoteOrderLinePriority != "") {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.loadPriorityAbbreviation == this.quoteOrderLinePriority);
            //this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.productID == this.productID);
        }
    }

    private filterByRoundTrip() {
        if (this.isRoundTrip) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.isRoundTrip == this.isRoundTrip);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.isRoundTrip == this.isRoundTrip);
        }
    }

    private filterByEmployees() {
        if (this.orderOwnerEmployeeID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.orderOwnerEmployeeID == this.orderOwnerEmployeeID);
        }
        if (this.accountRepID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.accountManagerEmployeeID == this.accountRepID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.accountManagerEmployeeID == this.accountRepID);
        }
        if (this.opsRepID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.opsRepEmployeeID == this.opsRepID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.opsRepEmployeeID == this.opsRepID);
        }
        if (this.salesRepID > 0) {
            //this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.salesEmployeeID == this.salesRepID);
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.awardedCarrierRepID == this.salesRepID);
        }
        if (this.orderCreatedByEmployeeID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.orderCreatedByEmployeeID == this.orderCreatedByEmployeeID);
            this.loadsRFQQuote = this.loadsRFQQuote.filter(o => o.createdByEmployeeID == this.orderCreatedByEmployeeID);
        }
        if (this.logisticSpecialistID > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o => o.logisticSpecialistID == this.logisticSpecialistID);
        }
        //console.log("filterByEmployees", this.orderOwnerEmployeeID, this.accountRepID, this.opsRepID, this.salesRepID, this.orderCreatedByEmployeeID, this.logisticSpecialistID);
    }

    private filterByTagTypes() {
        for (var i = 0; i < this.selectedTagTypes.length; i++) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(o =>
                o.tagTypes != ""
                && (
                    o.tagTypes == this.selectedTagTypes[i].tagTypeID.toString()
                    || o.tagTypes.startsWith(this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.includes("," + this.selectedTagTypes[i].tagTypeID + ",")
                    || o.tagTypes.endsWith("," + this.selectedTagTypes[i].tagTypeID)
                )
            );
        }
        //console.log("filterByTagTypes", this.selectedTagTypes, this.quoteOrderLinesPlanned);
    }

    private filterByC2C() {
        if (this.selectedC2C.length > 0) {
            this.quoteOrderLinesPlanned = this.quoteOrderLinesPlanned.filter(t =>
                this.selectedC2C.indexOf(t.legCntryToCntry) >= 0
            );
        }
    }

    public c2cChange(evt: any): void {
        console.log("c2cChange", evt);
        if (evt.value) {
            // Angular Material mat-select
            this.selectedC2C = Object.assign([], evt.value);
        }
        else {
            // Kendo multiselect
            this.selectedC2C = Object.assign([], evt);
        }
        this.applyFilters();
    }

    private filterStatuses() {
        this.loadsPlanned = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Planned");
        this.loadsAvailable = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Available");
        // Combine Tendered, Accepted, and Dispatched
        this.loadsTendered = this.quoteOrderLinesPlanned.filter(o =>
            o.loadStatus == "Tendered"
            || o.loadStatus == "Accepted"
            || o.loadStatus == "Dispatched"
        );
        //this.loadsAccepted = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Accepted");
        //this.loadsDispatched = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Dispatched");
        this.loadsStarted = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Started");
        this.loadsCompleted = this.quoteOrderLinesPlanned.filter(o => o.loadStatus == "Completed");

        this.ordersGrid = [...this.loadsPlanned, ...this.loadsAvailable, ...this.loadsTendered, ...this.loadsStarted, ...this.loadsCompleted];
        //this.ordersGrid = this.quoteOrderLinesPlanned.filter(o =>
        //    o.loadStatus == "Planned" && this.isShowPlanned
        //    || (o.loadStatus == "Tendered" || o.loadStatus == "Accepted" || o.loadStatus == "Dispatched") && this.isShowTendered
        //    || o.loadStatus == "Started" && this.isShowStarted
        //    || o.loadStatus == "Completed" && this.isShowCompleted
        //);
    }

    public isValidForm() {
        //console.log("isValidForm", this.beginDate, this.endDate);
        if (this.beginDate == null || this.endDate == null) {
            return false;
        }
        return true;
    }

    public resetFilters() {
        this.beginDate = new Date(new Date().setDate(new Date().getDate() - 7));
        this.endDate = new Date(new Date().setDate(new Date().getDate() + 1));
        this.orderPlannedForm.controls["originControl"].setValue("");
        this.orderPlannedForm.controls["destinationControl"].setValue("");
        this.orderPlannedForm.controls["parentCtrl"].setValue("");
        this.orderPlannedForm.controls["billToCtrl"].setValue("");
        this.orderPlannedForm.controls["carrierCtrl"].setValue("");
        this.orderNumber = '';
        this.parentCustomerCode = '';
        this.customerCode = '';
        this.carrierCode = '';
        this.modeId = 0;
        this.equipmentClassID = 0;
        this.trailerTypeID = 0;
        this.orderOwnerEmployeeID = 0;
        this.accountRepID = 0;
        this.opsRepID = 0;
        this.salesRepID = 0;
        this.orderCreatedByEmployeeID = 0;
        this.logisticSpecialistID = 0;
        this.quoteOrderLinePriority = "";
        this.selectedC2C.length = 0;
        this.selectedTagTypes.length = 0;
        this.isRoundTrip = false;
        this.applyFilters();
    }

    public getModeDescription(line: QuoteOrderLine): string {
        var mode = this.modes.filter(m => m.modeID == line.modeID);

        if (mode == null || mode.length < 1) return '';

        return mode[0].description;
    }

    public getTrailerTypeDescription(line: QuoteOrderLine): string {
        var trailerType = this.trailerTypeList.filter(t => t.trailerTypeID == line.trailerTypeID);

        if (trailerType == null || trailerType.length < 1) return '';

        return trailerType[0].description;
    }

    public toggleTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        if (idx >= 0) {
            this.selectedTagTypes.splice(idx, 1);
        }
        else {
            this.selectedTagTypes.push(tagType);
        }
        this.applyFilters();
        console.log("toggleTagType", tagType, this.selectedTagTypes);
    }

    public checkSelectedTagType(tagType: SearchTagType) {
        var idx: number = this.selectedTagTypes.findIndex(t => t.tagTypeID == tagType.tagTypeID);
        //console.log("checkSelectedTagType", idx);
        if (idx >= 0) {
            return "text-primary";
        }
        else {
            return "";
        }
    }

    public setColSize() {
        var cols = 0;
        cols += (this.isShowPlanned ? 1 : 0);
        cols += (this.isShowAvailable ? 1 : 0);
        cols += (this.isShowTendered ? 1 : 0);
        cols += (this.isShowAccepted ? 1 : 0);
        cols += (this.isShowDispatched ? 1 : 0);
        cols += (this.isShowStarted ? 1 : 0);
        cols += (this.isShowCompleted ? 1 : 0);

        // Status column size = 12 / num cols
        var statusColSize = Math.floor(12 / cols);
        if (statusColSize < 2) {
            statusColSize = 2;
        }
        this.colSize = statusColSize;

        // Card column size = num cols * 2
        // 1 col = size 2
        // 2 col = size 4
        // 3 col = size 6
        // 4 col = size 12
        // 5 col = size 12
        // 6 col = size 12
        var cardColSize = cols * 2;
        if (cardColSize > 6 && cardColSize < 12) {
            cardColSize = 12;
        }
        this.cardSize = cardColSize;

        if (this.resultsView == "OrderList") {
            this.filterStatuses();
        }
    }

    public openDialogClick(load: QuoteOrderLinePlannedLoad) {
        var newRelativeUrl = this.router.createUrlTree(["order-entry", load.quoteOrderID]);
        var baseUrl = window.location.href.replace(this.router.url, "");
        window.open(baseUrl + newRelativeUrl, "_blank");
        //console.log("currentDataCollection", this.dataService.dataCollection, this.dataService.currentDataCollection);
    }

    public toggleFlag(div: string) {
        this.divFlags[div] = !this.divFlags[div];
    }
}
